<template>
  <div class="rang-rank" v-show="cars.length > 0" @click.stop>
    <div class="rang-rank__container">
      <!-- 标题栏 -->
      <div class="rang-rank__title">
        <div class="rang-rank__heading">Rang Rank</div>
        <a class="rang-rank__view" :href="getHrefForAll()">
          <div class="rang-rank__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="rang-rank__icon" alt="view all icon">
        </a>
      </div>

      <!-- 内容区域 -->
      <div class="rang-rank__content">
        <!-- 左侧导航箭头（PC端） -->
        <div class="rang-rank__nav-left rang-rank__nav-arrow rang-rank__nav-arrow--left"
          :class="{'rang-rank__nav-arrow--disabled': currentPage === 1}"
          v-if="deviceType !== 'mobile' && totalPages > 1" @click="prevPage">
          <svg class="rang-rank__arrow-icon rang-rank__arrow-icon--left"
            xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.81151 6L5.78094 1.46355C6.07302 1.12975 6.07302 0.584148 5.78094 0.250349C5.48887 -0.0834497 5.01146 -0.0834497 4.71938 0.250349L0.218581 5.39407C0.145855 5.47718 0.0907245 5.5737 0.0543615 5.67693C-0.00898042 5.8579 -0.0171914 6.05898 0.0309015 6.24532C0.0379395 6.27213 0.0461505 6.2976 0.0543615 6.32441C0.0907245 6.42764 0.145855 6.52416 0.218581 6.60727L4.71821 11.7497C5.01028 12.0835 5.48769 12.0835 5.77977 11.7497C6.07185 11.4159 6.07185 10.8702 5.77977 10.5364L1.81151 6Z"
              fill="white" />
          </svg>
        </div>

        <!-- 卡片展示区域 -->
        <div class="rang-rank__cards-wrapper">
          <div class="rang-rank__cards">
            <a v-for="(car, index) in displayedCars" :key="`car-${index}`" class="rang-rank__card"
              :href="getHrefForDetail(car)" :data-empty="car.isEmpty">
              <!-- 图片区域 -->
              <div class="rang-rank__image-container">
                <img :src="car.image" class="rang-rank__pic" alt="car image">
              </div>

              <!-- 底部信息区域 -->
              <div class="rang-rank__info">
                <!-- 加速时间 -->
                <div class="rang-rank__speed">
                  <div class="rang-rank__speed-value">
                    <div class="rang-rank__speed-number">{{ car.speedValue }}</div>
                  </div>
                  <div class="rang-rank__speed-label">
                    <div class="rang-rank__speed-text">0–60-MPH Times</div>
                  </div>
                </div>

                <!-- 品牌和名称 -->
                <div class="rang-rank__details">
                  <div class="rang-rank__car-info">
                    <div class="rang-rank__brand">{{ car.brand }}</div>
                    <div class="rang-rank__model">{{ car.model }}</div>
                  </div>
                  <div class="rang-rank__logo">
                    <img :src="car.logo" alt="brand logo">
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- 右侧导航箭头（PC端） -->
        <div class="rang-rank__nav-right rang-rank__nav-arrow rang-rank__nav-arrow--right"
          v-if="deviceType !== 'mobile' && totalPages > 1" @click="nextPage"
          :class="{'rang-rank__nav-arrow--disabled': currentPage >= totalPages}">
          <svg class="rang-rank__arrow-icon" xmlns="http://www.w3.org/2000/svg" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M4.18849 6L0.219058 1.46355C-0.073019 1.12975 -0.073019 0.584148 0.219058 0.250349C0.511134 -0.0834497 0.988545 -0.0834497 1.28062 0.250349L5.78142 5.39407C5.85414 5.47718 5.90928 5.5737 5.94564 5.67693C6.00898 5.8579 6.01719 6.05898 5.9691 6.24532C5.96206 6.27213 5.95385 6.2976 5.94564 6.32441C5.90928 6.42764 5.85414 6.52416 5.78142 6.60727L1.28179 11.7497C0.989717 12.0835 0.512307 12.0835 0.22023 11.7497C-0.0718465 11.4159 -0.0718465 10.8702 0.22023 10.5364L4.18849 6Z"
              fill="white" />
          </svg>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarRangRank',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    // 计算当前显示的卡片
    displayedCars () {
      // 移动端展示所有车辆，不做分页
      if (this.deviceType === 'mobile') {
        return this.cars;
      }

      // PC端保持原来的分页逻辑
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const items = this.cars.slice(start, start + this.itemsPerPage);

      // The effect should be more subtle for Rang Rank
      if (items.length === 3) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
      } else if (items.length === 2) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
        items.push(lastItemStyles);
      } else if (items.length === 1) {
        const lastItemStyles = { ...items[0], isEmpty: true };
        items.push(lastItemStyles);
        items.push(lastItemStyles);
        items.push(lastItemStyles);
      }

      return items;
    },
    // 计算总页数
    totalPages () {
      return Math.ceil(this.cars.length / this.itemsPerPage);
    }
  },
  data () {
    return {
      currentPage: 1,
      itemsPerPage: 3, // 调整为3个，一行三个卡片
      cars: [],
      loading: false,
      error: null
    }
  },
  mounted () {
    this.fetchRangRankData();
  },
  methods: {
    // 从API获取排名数据
    async fetchRangRankData () {
      try {
        this.loading = true;
        this.error = null;

        // 从store获取域名配置的主题过滤条件
        const themeFilters = this.$store.getters.domainConfig?.themeFilters || {};
        // 获取webIndex
        const webIndex = this.$store.getters.domainConfig?.webIndex || 1;

        // 调用global.js中的getRecommendedRangRank方法获取数据
        const params = {
          ...themeFilters,
          webIndex
        };
        const res = await this.$global.server.getRecommendedRangRank(params);
        if (res.code === 200) {
          // 处理API返回的数据
          const apiData = res.data || [];
          if (apiData.length > 0) {
            const processedData = apiData.map(item => {
              // 从photos字段提取第一张图片作为封面
              const photos = item.photos ? item.photos.split(',') : [];
              const firstPhoto = photos.length > 0 ? photos[0] : require('@/assets/car-recommend-img.png');

              // 返回处理后的数据，映射字段名称
              return {
                id: item.id,
                model: item.name, // API中是name字段，映射为model
                brand: item.brand,
                logo: item.logoUrl || require('@/assets/car-logo.svg'), // 使用默认logo，因为API中没有提供
                year: item.year || item.marketTime?.substring(0, 4) || '-',
                category: item.purpose || '-', // 使用purpose字段作为category
                bodyType: item.type || '-', // 使用type字段作为bodyType
                price: this.formatPrice(item.leastPrice, item.mostPrice) || item.price || '-',
                image: item.cover || firstPhoto, // 使用cover字段，如果没有则使用firstPhoto
                speedValue: item.accelerationTime ? `${item.accelerationTime}s` : '-', // 添加's'后缀
                isEmpty: false
              };
            });

            this.cars = processedData;
            console.log('[CarRangRank] 获取排名数据:', this.cars.length);
            // 重置当前页为第一页
            this.currentPage = 1;
          } else {
            // 如果没有数据，则设置为空数组
            this.cars = [];
            console.log('[CarRangRank] 没有排名数据');
          }
        } else {
          throw new Error(res.message || 'Failed to get rang rank data');
        }
      } catch (error) {
        console.error('[CarRangRank] 获取排名数据错误:', error);
        this.error = error.message || 'Failed to get rang rank data';
        this.cars = [];
      } finally {
        this.loading = false;
      }
    },

    // 格式化价格显示
    formatPrice (leastPrice, mostPrice) {
      if (!leastPrice && !mostPrice) return null;

      const formatNumber = (num) => {
        if (!num) return null;
        // 将价格格式化为$xx,xxx格式
        return '$' + num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

      if (leastPrice && mostPrice) {
        // 有最低价和最高价，显示价格区间
        return `${formatNumber(leastPrice)}-${formatNumber(mostPrice)}`;
      } else if (leastPrice) {
        // 只有最低价
        return `>${formatNumber(leastPrice)}`;
      } else if (mostPrice) {
        // 只有最高价
        return `<${formatNumber(mostPrice)}`;
      }

      return null;
    },

    // 上一页
    prevPage () {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },

    // 下一页
    nextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },

    // 跳转到指定页
    goToPage (page) {
      this.currentPage = page;
    },

    // 计算最大页码
    maxPage () {
      if (this.cars.length <= 3) return 0;
      return Math.ceil(this.cars.length / 3) - 1;
    },

    // Generate href for "View All" link
    getHrefForAll () {
      const currentChannel = this.$route.params.channel;
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/car-list${fullQueryString}`;
      }
      return `/car-list${fullQueryString}`;
    },

    // Generate href for car detail page
    getHrefForDetail (car) {
      if (!car || !car.id || car.isEmpty) {
        return 'javascript:void(0);';
      }
      const currentChannel = this.$route.params.channel;
      const formattedName = encodeURIComponent((car.model || '').replace(/\s+/g, '-'));
      const queryString = new URLSearchParams(this.$route.query).toString();
      const fullQueryString = queryString ? `?${queryString}` : '';

      if (currentChannel) {
        return `/${currentChannel}/cars/${formattedName}/${car.id}${fullQueryString}`;
      }
      return `/cars/${formattedName}/${car.id}${fullQueryString}`;
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.rang-rank {
	padding: rem(60) 0;
	background: #ffffff;

	&__container {
		padding: 0 rem(120);
	}

	&__title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: rem(20);
		padding: 0 rem(40);
	}

	&__heading {
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
		color: #141414;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(12);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 600;
		color: var(--theme-color);
	}

	&__icon {
		width: rem(16);
		height: rem(16);
	}

	&__content {
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	&__cards-wrapper {
		width: 100%;
		overflow: hidden;
	}

	&__cards {
		display: flex;
		gap: rem(20);
		justify-content: space-between;
		width: 100%;
		// max-width: rem(1200);
		margin: 0 auto;
	}

	&__card {
		background: linear-gradient(180deg, rgba(20, 20, 20, 0.08) 0%, rgba(255, 255, 255, 0.08) 50%, rgba(255, 255, 255, 0.08) 100%);
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		padding: rem(20);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		flex: 0 0 calc((100% - rem(40)) / 3); /* 使每个子元素占1/3的宽度 */
		position: relative;
		cursor: pointer;
		transition: transform 0.3s ease, box-shadow 0.3s ease;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 rem(8) rem(16) rgba(0, 0, 0, 0.1);
		}

		&[data-empty='true'] {
			visibility: hidden;
		}
	}

	&__image-container {
		width: 100%;
		height: rem(232);
		position: relative;
	}

	&__pic {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: rem(16);
		border: 1px solid #ffffff;
	}

	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}

	&__speed {
		display: flex;
		flex-direction: row;
	}

	&__speed-value {
		background: var(--theme-color);
		border-radius: rem(8) 0 0 rem(8);
		padding: rem(4) rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-number {
		color: #ffffff;
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 700;
	}

	&__speed-label {
		background: #141414;
		border-radius: 0 rem(8) rem(8) 0;
		padding: rem(4) rem(12);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__speed-text {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(20);
		font-weight: 400;
	}

	&__details {
		display: flex;
		flex-direction: row;
		align-items: flex-end;
		justify-content: space-between;
	}

	&__car-info {
		display: flex;
		flex-direction: column;
		gap: rem(12);
	}

	&__brand {
		color: #777777;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
	}

	&__model {
		color: #141414;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 600;
	}

	&__logo {
		width: rem(40);
		height: rem(40);
		background: #fff;
		border-radius: 50%;
		padding: rem(2);
		overflow: hidden;
		border: 1px solid #e9e9e9;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	&__nav-arrow {
		width: rem(24);
		height: rem(24);
		border-radius: rem(8);
		background: #141414;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		position: absolute;
		z-index: 10;
		transition: all 0.3s ease;
		top: 50%;
		transform: translateY(-50%);

		&:hover {
			// background: #f5f5f5;
			opacity: 0.7;
		}

		&--left {
			left: rem(-40);

			.rang-rank__arrow-icon {
				transform: rotate(360deg);
			}
		}

		&--right {
			right: rem(-40);
		}

		&--disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
	}

	&__arrow-icon {
		width: rem(6);
		height: rem(12);
	}

	// &__nav-left,
	// &__nav-right {
	// 	position: absolute;
	// 	top: 50%;
	// 	transform: translateY(-50%);
	// 	width: rem(24);
	// 	height: rem(24);
	// 	background: #141414;
	// 	border-radius: rem(8);
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: center;
	// 	cursor: pointer;
	// 	z-index: 10;

	// 	img {
	// 		width: rem(6);
	// 		height: rem(12);
	// 		filter: brightness(0) invert(1);
	// 	}
	// }

	&__nav-dots {
		display: flex;
		gap: rem(8);
		margin-top: rem(20);
	}

	&__nav-dot {
		width: rem(8);
		height: rem(8);
		background-color: #e0e0e0;
		border-radius: 50%;
		cursor: pointer;
		transition: all 0.3s ease;

		&--active {
			background-color: var(--theme-color);
		}
	}
}

// 移动端适配
.detect_deviece_mobile {
	.rang-rank {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
	}

	.rang-rank {
		padding: rem(40) 0;

		&__container {
			padding: 0 0 0 rem(16);
		}

		&__title {
			padding: 0 rem(16) 0 0;
		}

		&__cards {
			display: flex;
			flex-wrap: nowrap;
			overflow-x: auto;
			gap: rem(8);
			padding-bottom: rem(10);
			scrollbar-width: none;
			-ms-overflow-style: none;
			&::-webkit-scrollbar {
				display: none;
			}
			margin: 0 rem(-16);
			padding: 0 rem(16);
			width: calc(100% + rem(32));
		}

		&__card {
			flex: 0 0 rem(343);
			min-width: rem(343);
		}

		&__image-container {
			height: rem(203);
		}
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.rang-rank {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}
</style> 